import React, { useState } from 'react';
import emailjs from 'emailjs-com';

interface FeedbackFormProps {
  onClose: () => void;
}

const FeedbackForm: React.FC<FeedbackFormProps> = ({ onClose }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const validateEmail = (email: string) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!name.trim()) {
      setError('Please enter your name.');
      return;
    }
    if (!message.trim()) {
      setError('Please enter your feedback message.');
      return;
    }
    if (email && !validateEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setSubmitting(true);
    try {
      const serviceId = 'service_gpccn5n';
      const templateId = 'template_gxdfvij';
      const userId = 'xXX1_ntkm19hc0nVH';
      const templateParams = {
        name,
        email,
        message,
      };
      console.log('Sending to EmailJS:', templateParams);
      await emailjs.send(serviceId, templateId, templateParams, userId);
      setSuccess(true);
    } catch (err) {
      setError('Failed to send feedback. Please try again later.');
    } finally {
      setSubmitting(false);
    }
  };

  if (success) {
    return (
      <div className="p-8 max-w-md w-full bg-gray-800 rounded-2xl shadow-xl flex flex-col items-center">
        <div className="text-green-400 text-2xl mb-2">Thank you!</div>
        <div className="text-gray-200 mb-4 text-center">Your feedback has been sent.</div>
        <button className="px-6 py-2 rounded-lg bg-blue-500 hover:bg-blue-600 text-white font-semibold" onClick={onClose}>Close</button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="p-8 max-w-md w-full bg-gray-800 rounded-2xl shadow-xl flex flex-col gap-4">
      <h2 className="text-xl font-semibold text-white text-center mb-2">Send Your Feedback</h2>
      <label className="text-gray-300 text-sm font-medium">Your Name</label>
      <input
        type="text"
        className="rounded-lg px-4 py-2 bg-gray-900 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        value={name}
        onChange={e => setName(e.target.value)}
        placeholder="Your name"
        disabled={submitting}
        required
      />
      <label className="text-gray-300 text-sm font-medium">Your Email (optional)</label>
      <input
        type="email"
        className="rounded-lg px-4 py-2 bg-gray-900 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        value={email}
        onChange={e => setEmail(e.target.value)}
        placeholder="you@email.com (optional)"
        disabled={submitting}
      />
      <label className="text-gray-300 text-sm font-medium">Message</label>
      <textarea
        className="rounded-lg px-4 py-2 bg-gray-900 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 min-h-[100px]"
        value={message}
        onChange={e => setMessage(e.target.value)}
        placeholder="Enter your feedback here..."
        disabled={submitting}
        required
      />
      {error && <div className="text-red-400 text-sm text-center">{error}</div>}
      <div className="flex gap-2 mt-2">
        <button
          type="submit"
          className="flex-1 px-6 py-2 rounded-lg bg-blue-500 hover:bg-blue-600 text-white font-semibold disabled:opacity-60"
          disabled={submitting}
        >
          {submitting ? 'Sending...' : 'Send Feedback'}
        </button>
        <button
          type="button"
          className="flex-1 px-6 py-2 rounded-lg bg-gray-600 hover:bg-gray-700 text-white font-semibold"
          onClick={onClose}
          disabled={submitting}
        >
          Cancel
        </button>
      </div>
    </form>
  );
};

export default FeedbackForm; 